import type { Logger } from "@expert/logging";

import { getCustomerDetailsApi } from "./api";

export type PlaceResponse = {
    Results?: PlaceResult[];
};

export type PlaceResult = {
    Place?: Place;
};

export type Place = {
    TimeZone?: TimeZone;
};

export type TimeZone = {
    Name?: string;
    Offset?: number;
};

export type GetPlaceOptions = {
    limit?: number;
};

export async function getPlace(
    logger: Logger,
    searchText: string,
    options: GetPlaceOptions = {},
): Promise<PlaceResponse | null> {
    try {
        const client = getCustomerDetailsApi();
        return await client
            .post("v1/place", { json: { Text: searchText, MaxResults: options.limit } })
            .json<PlaceResponse>();
    } catch (error) {
        logger.warn({ error }, "error searching for place");
        return null;
    }
}
